import { useEffect, useState } from 'react'

const useShowTWAUpgradeWarning = (isTwa, minVersion) => {
  const [showWarning, setShowWarning] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const localStorageVersionCode = localStorage.getItem('versionCode')
    const urlVersionCode = parseInt(urlParams.get('versionCode'), 10)

    const versionCode = Number.isNaN(urlVersionCode) ? localStorageVersionCode : urlVersionCode

    if (versionCode) {
      localStorage.setItem('versionCode', versionCode)
    }

    if ((isTwa && versionCode < minVersion) || (isTwa && !versionCode)) {
      setShowWarning(true)
    }
  }, [minVersion, isTwa])

  return showWarning
}

export default useShowTWAUpgradeWarning
